import { useTranslation as useTranslationI18Next } from 'react-i18next';

import * as Translation from 'types/_general/Translation';

import useCultureCode from './redux/useCultureCode';

export default function useTranslationHook() {
	const cultureCode = useCultureCode();
	const { t } = useTranslationI18Next();

	function translate(input: Translation.Type<string>): string {
		return Translation.getFirstTranslation(input, cultureCode);
	}

	return {
		t: t,
		tl: translate,
		cc: cultureCode,
	};
}
